import { render, staticRenderFns } from "./shopPromotionsProducts.vue?vue&type=template&id=705052de&scoped=true&"
import script from "./shopPromotionsProducts.vue?vue&type=script&lang=js&"
export * from "./shopPromotionsProducts.vue?vue&type=script&lang=js&"
import style0 from "./shopPromotionsProducts.vue?vue&type=style&index=0&id=705052de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705052de",
  null
  
)

export default component.exports